export default [
  {
    path: '/:projectId?/error-400',
    name: 'error-400',
    component: () => import('@/views/pages/error/Error400.vue'),
    meta: {
      isPublic: true,
      pageTitle: 'Error',
      breadcrumb: [{ text: 'Error 400', disabled: true }],
    },
    props: {
      showRefresh: false,
    },
  },
  {
    path: '/:projectId?/error-403',
    name: 'error-403',
    component: () => import('@/views/pages/error/Error403.vue'),
    meta: {
      isPublic: true,
      pageTitle: 'Error',
      breadcrumb: [{ text: 'Error 403', disabled: true }],
    },
    props: {
      showRefresh: false,
    },
  },
  {
    path: '/:projectId?/error-404',
    name: 'error-404',
    component: () => import('@/views/pages/error/Error404.vue'),
    meta: {
      isPublic: true,
      pageTitle: 'Error',
      breadcrumb: [{ text: 'Error 404', disabled: true }],
    },
    props: {
      showRefresh: false,
    },
  },
  {
    path: '/:projectId?/error-409',
    name: 'error-409',
    component: () => import('@/views/pages/error/Error409.vue'),
    meta: {
      isPublic: true,
      pageTitle: 'Error',
      breadcrumb: [{ text: 'Error 409', disabled: true }],
    },
    props: {
      showRefresh: false,
    },
  },
  {
    path: '/:projectId?/error-500',
    name: 'error-500',
    component: () => import('@/views/pages/error/Error500.vue'),
    meta: {
      isPublic: true,
      pageTitle: 'Error',
      breadcrumb: [{ text: 'Error 500', disabled: true }],
    },
    props: {
      showRefresh: false,
    },
  },
  {
    path: '/:projectId?/error-503',
    name: 'error-503',
    component: () => import('@/views/pages/error/Error503.vue'),
    meta: {
      isPublic: true,
      pageTitle: 'Error',
      breadcrumb: [{ text: 'Error 503', disabled: true }],
    },
    props: {
      showRefresh: false,
    },
  },
]
